
let serverUrl = "https://test.asa-oil.ir/";

const header = () => {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    token: localStorage.getItem("apiKey"),
    cache: "no-cache",
  };
};

//bussinessReport
export const GetBusReport = (page, count) => {
  return fetch(serverUrl + `api/BusinessReport/${page}/${count}`, {
    method: "GET",
    headers: header(),
  });
};

export const DeleteBusReport = (storeId) => {
  return fetch(serverUrl + `api/BusinessReport/${storeId}`, {
    method: "DELETE",
    headers: header(),
  });
};
//////////////
export const DeleteStore = (storeId) => {
  return fetch(serverUrl + `api/Store/${storeId}`, {
    method: "DELETE",
    headers: header(),
  });
};
// User

export const IsAuthorized = () => {
  return fetch(serverUrl + "api/User/isAuthorized", {
    method: "POST",
    headers: header(),
  });
};

export const Login = (request) => {
  return fetch(serverUrl + "api/User/Login", {
    method: "POST",
    headers: header(),
    body: JSON.stringify(request),
  });
};

export const AddUser = (request) => {
  return fetch(serverUrl + "api/User/SignUp", {
    method: "POST",
    headers: header(),
    body: JSON.stringify(request),
  });
};

export const GetUsers = (page, count) => {
  return fetch(serverUrl + `api/User/${page}/${count}`, {
    method: "GET",
    headers: header(),
  });
};
export const GetAgentss = (page, count) => {
  return fetch(serverUrl + `api/User/userAgent`, {
    method: "GET",
    headers: header(),
  });
};
export const HasTell = (tell) => {
  return fetch(serverUrl + `api/User/HasTell/${tell}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetUser = (userId) => {
  return fetch(serverUrl + `api/User/${userId}/Complet`, {
    method: "GET",
    headers: header(),
  });
};

export const filterbyuseragent = (offset, limit) => {
  return fetch(serverUrl + `api/User/userAgent/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};
export const filterbyuserGuest = (offset, limit) => {
  return fetch(serverUrl + `api/User/userGuest/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetUsersByUserType = (offset, limit, userType) => {
  return fetch(
    serverUrl +
      `api/User${userType ? `/byUserType/${userType}` : ""}/${offset}/${limit}`,
    {
      method: "GET",
      headers: header(),
    }
  );
};

export const GetVisitorCustomers = (visitorId, offset, limit) => {
  return fetch(
    serverUrl + `api/User/VisitorCustomers/${visitorId}/${offset}/${limit}`,
    {
      method: "GET",
      headers: header(),
    }
  );
};

export const EditUser = (id, request) => {
  return fetch(serverUrl + `api/User/edit-personalinfo/${id}`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(request),
  });
};

export const EditUserPass = (id, request) => {
  return fetch(serverUrl + `api/User/changePassword/${id}`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(request),
  });
};

export const DeleteUser = (userId) => {
  return fetch(serverUrl + `api/User/${userId}`, {
    method: "DELETE",
    headers: header(),
  });
};

export const ForgetPassword = (tell) => {
  return fetch(serverUrl + `api/User/forgetpassword/${tell}`, {
    method: "POST",
    headers: header(),
    // body: JSON.stringify(phoneNumber),
  });
};

export const Logout = () => {
  return fetch(serverUrl + "api/User/logout", {
    method: "POST",
    headers: header(),
  });
};

// agents

export const GetAgents = (page, count) => {
  return fetch(serverUrl + `api/AdminBrand/${page}/${count}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetAllByAdmin = (key) => {
  return fetch(serverUrl + "api/AdminBrand/AllByAdmin/" + key, {
    method: "GET",
    headers: header(),
  });
};
export const GetAllByCity = (key) => {
  return fetch(serverUrl + "api/AdminBrand/AllByCity/" + key, {
    method: "GET",
    headers: header(),
  });
};
export const GetAllByBrand = (key) => {
  return fetch(serverUrl + "api/AdminBrand/AllByBrand/" + key, {
    method: "GET",
    headers: header(),
  });
};
export const GetAgent = (key) => {
  return fetch(serverUrl + "api/AdminBrand/" + key, {
    method: "GET",
    headers: header(),
  });
};

export const UpdateAgent = (setting) => {
  return fetch(serverUrl + "api/AdminBrand", {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(setting),
  });
};

export const DeleteAgent = (key) => {
  return fetch(serverUrl + "api/AdminBrand/" + key, {
    method: "DELETE",
    headers: header(),
  });
};
export const AddAgent = (setting) => {
  return fetch(serverUrl + "api/AdminBrand", {
    method: "POST",
    headers: header(),
    body: JSON.stringify(setting),
  });
};

// Setting

export const GetSettings = (page, count) => {
  return fetch(serverUrl + `api/Setting/list/${page}/${count}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetSetting = (key) => {
  return fetch(serverUrl + "api/Setting/" + key, {
    method: "GET",
    headers: header(),
  });
};

export const UpdateSetting = (setting) => {
  return fetch(serverUrl + "api/Setting", {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(setting),
  });
};

export const DeleteSetting = (key) => {
  return fetch(serverUrl + "api/Setting/" + key, {
    method: "DELETE",
    headers: header(),
  });
};
export const AddSetting = (setting) => {
  return fetch(serverUrl + "api/Setting", {
    method: "POST",
    headers: header(),
    body: JSON.stringify(setting),
  });
};

// Product

export const GetGoodsType = (offset, limit) => {
  return fetch(serverUrl + `api/GoodsType/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};
export const GetProducts = (offset, limit) => {
  return fetch(serverUrl + `api/goods/${offset}/${limit}/complet`, {
    method: "GET",
    headers: header(),
  });
};

export const GetProductsByBrandAndGoodType = (
  offset,
  limit,
  brandId,
  goodTypeId
) => {
  return fetch(
    serverUrl +
      `api/goods/ByBrandandGType/${brandId ? brandId : null}/${
        goodTypeId ? goodTypeId : null
      }/${offset}/${limit}`,
    {
      method: "GET",
      headers: header(),
    }
  );
};

export const GetProduct = (productId) => {
  return fetch(serverUrl + `api/goods/${productId}`, {
    method: "GET",
    headers: header(),
  });
};

export const FilterProductByName = (name) => {
  return fetch(serverUrl + `api/Goods/Search/${name}/0/9999`, {
    method: "GET",
    headers: header(),
  });
};

export const AddProduct = (product) => {
  return fetch(serverUrl + "api/goods", {
    method: "POST",
    headers: header(),
    body: JSON.stringify(product),
  });
};

export const EditProduct = (product) => {
  return fetch(serverUrl + `api/Goods`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(product),
  });
};
export const SetPermission = (user) => {
  return fetch(serverUrl + `api/goods`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(user),
  });
};
export const SetUserPermission = (id) => {
  return fetch(serverUrl + `api/User/setPermission/${id}`, {
    method: "PUT",
    headers: header(),
    // body: JSON.stringify(user),
  });
};
export const SetBusinessPermission = (id) => {
  return fetch(serverUrl + `api/Business/SetConfirm/${id}`, {
    method: "PUT",
    headers: header(),
    // body: JSON.stringify(user),
  });
};

export const DeleteProduct = (productId) => {
  return fetch(serverUrl + `api/goods/${productId}`, {
    method: "DELETE",
    headers: header(),
  });
};

// Brand

export const GetBrands = (offset, limit) => {
  return fetch(serverUrl + `api/brand/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetAllBrands = () => {
  return fetch(serverUrl + `api/brand`, {
    method: "GET",
    headers: header(),
  });
};


export const GetAllCityBrands = () => {
  return fetch(serverUrl + `api/CityBrand/0/9999`, {
    method: "GET",
    headers: header(),
  });
};

export const GetBrand = (brandId) => {
  return fetch(serverUrl + `api/brand/${brandId}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddBrand = (brand) => {
  return fetch(serverUrl + "api/brand", {
    method: "POST",
    headers: header(),
    body: JSON.stringify(brand),
  });
};

export const EditBrand = (brand) => {
  return fetch(serverUrl + `api/Brand`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(brand),
  });
};

export const DeleteBrand = (brandId) => {
  return fetch(serverUrl + `api/brand/${brandId}`, {
    method: "DELETE",
    headers: header(),
  });
};

// VehicleBrand

export const GetVehicleBrands = (offset, limit) => {
  return fetch(serverUrl + `api/vehiclebrand/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetAllVehicleBrands = () => {
  return fetch(serverUrl + `api/vehiclebrand`, {
    method: "GET",
    headers: header(),
  });
};

export const GetVehicleBrand = (id) => {
  return fetch(serverUrl + `api/vehiclebrand/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddVehicleBrand = (vehicleBrand) => {
  return fetch(serverUrl + "api/vehiclebrand", {
    method: "POST",
    headers: header(),
    body: JSON.stringify(vehicleBrand),
  });
};

export const EditVehicleBrand = (vehicleBrand) => {
  return fetch(serverUrl + `api/vehiclebrand`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(vehicleBrand),
  });
};

export const DeleteVehicleBrand = (id) => {
  return fetch(serverUrl + `api/vehiclebrand/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

// VehicleClass

export const GetVehicleClassesByBrand = (brandId) => {
  return fetch(serverUrl + `api/vehicleBrand/${brandId}/vehicleClass`, {
    method: "GET",
    headers: header(),
  });
};

export const DeleteVehicleClass = (id) => {
  return fetch(serverUrl + `api/vehicleClass/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

export const GetVehicleClasses = (offset, limit) => {
  return fetch(serverUrl + `api/vehicleClass/${offset}/${limit}/complet`, {
    method: "GET",
    headers: header(),
  });
};

export const GetVehicleClass = (id) => {
  return fetch(serverUrl + `api/vehicleClass/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddVehicleClass = (vehicleClass) => {
  return fetch(serverUrl + `api/vehicleClass`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(vehicleClass),
  });
};

export const EditVehicleClass = (vehicleClass) => {
  return fetch(serverUrl + `api/vehicleClass`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(vehicleClass),
  });
};

// Vehicle

export const DeleteVehicle = (id) => {
  return fetch(serverUrl + `api/vehicle/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

export const GetVehicles = (offset, limit) => {
  return fetch(serverUrl + `api/vehicle/${offset}/${limit}/complet`, {
    method: "GET",
    headers: header(),
  });
};

export const GetVehicle = (id) => {
  return fetch(serverUrl + `api/vehicle/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddVehicle = (vehicle) => {
  return fetch(serverUrl + `api/vehicle`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(vehicle),
  });
};

export const EditVehicle = (vehicle) => {
  return fetch(serverUrl + `api/vehicle`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(vehicle),
  });
};
//machinecomplimentary

export const GetMachineComp = (offset, limit) => {
  return fetch(serverUrl + `api/MachineComplimentray/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};
export const DeleteMachineComplimentray = (id) => {
  return fetch(serverUrl + `api/MachineComplimentray/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};
// PaymentType

export const GetAllPaymentTypes = () => {
  return fetch(serverUrl + `api/paymentType`, {
    method: "GET",
    headers: header(),
  });
};

export const GetPaymentTypes = (offset, limit) => {
  return fetch(serverUrl + `api/paymentType/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetPaymentType = (id) => {
  return fetch(serverUrl + `api/paymentType/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddPaymentType = (paymentType) => {
  return fetch(serverUrl + `api/paymentType`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(paymentType),
  });
};

export const EditPaymentType = (id, paymentType) => {
  return fetch(serverUrl + `api/paymentType`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(paymentType),
  });
};

export const DeletePaymentType = (id) => {
  return fetch(serverUrl + `api/paymentType/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

// complimentary

export const GetAllComplimentray = () => {
  return fetch(serverUrl + `api/Complimentray`, {
    method: "GET",
    headers: header(),
  });
};

export const GetComplimentray = (offset, limit) => {
  return fetch(serverUrl + `api/Complimentray/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetComplimentrayByid = (id) => {
  return fetch(serverUrl + `api/Complimentray/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddComplimentray = (paymentType) => {
  return fetch(serverUrl + `api/Complimentray`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(paymentType),
  });
};

export const EditComplimentraye = (id, paymentType) => {
  return fetch(serverUrl + `api/Complimentray`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(paymentType),
  });
};

export const DeleteComplimentray = (id) => {
  return fetch(serverUrl + `api/Complimentray/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

// GoodsType

export const GetGoodsTypes = () => {
  return fetch(serverUrl + `api/goodsType`, {
    method: "GET",
    headers: header(),
  });
};

// SubCategory

export const GetSubCategoriesByBrand = (brandId) => {
  return fetch(serverUrl + `api/brand/${brandId}/SubCategories`, {
    method: "GET",
    headers: header(),
  });
};

export const GetSubCategoriesByBrandPage = (brandId, offset, limit) => {
  return fetch(
    serverUrl + `api/brand/${brandId}/${offset}/${limit}/SubCategories`,
    {
      method: "GET",
      headers: header(),
    }
  );
};

export const DeleteSubCategory = (id) => {
  return fetch(serverUrl + `api/subcategory/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

export const GetSubCategories = (offset, limit) => {
  return fetch(serverUrl + `api/subcategory/${offset}/${limit}/complet`, {
    method: "GET",
    headers: header(),
  });
};

export const AddSubCategory = (subCategory) => {
  return fetch(serverUrl + `api/subcategory`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(subCategory),
  });
};

export const EditSubCategory = (subCategory) => {
  return fetch(serverUrl + `api/subCategory`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(subCategory),
  });
};

export const GetSubCategory = (id) => {
  return fetch(serverUrl + `api/subcategory/${id}`, {
    method: "GET",
    headers: header(),
  });
};
export const SearchUser = (name, skip, count) => {
  return fetch(serverUrl + `api/User/Search/${name}/${skip}/${count}`, {
    method: "GET",
    headers: header(),
  });
};
export const SearchUserPhone = (phone, skip, count) => {
  return fetch(serverUrl + `api/User/SearchByPhone/${phone}/${skip}/${count}`, {
    method: "GET",
    headers: header(),
  });
};

//province

export const GetAllProvince = () => {
  return fetch(serverUrl + `api/Province/`, {
    method: "GET",
    headers: header(),
  });
};
export const GetProvinces = (offset, limit) => {
  return fetch(serverUrl + `api/Province/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetCityByProvinceId = (id) => {
  return fetch(serverUrl + `api/City/GetByProvinceId/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetProvince = (id) => {
  return fetch(serverUrl + `api/Province/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddProvince = (Province) => {
  return fetch(serverUrl + `api/Province`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(Province),
  });
};

export const EditProvince = (ProvinceId, Province) => {
  return fetch(serverUrl + `api/Province/Ads`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(Province),
  });
};

export const DeleteProvince = (id) => {
  return fetch(serverUrl + `api/Province/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};
//bussinessCategory

export const GetBusinessCategories = (offset, limit) => {
  return fetch(serverUrl + `api/BusinessCategory/${offset}/${limit}`, {
    method: "GET",
    headers: header,
  });
};

export const GetBusinessCategory = (id) => {
  return fetch(serverUrl + `api/BusinessCategory/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddBusinessCategory = (BusinessCategory) => {
  return fetch(serverUrl + `api/BusinessCategory`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(BusinessCategory),
  });
};

export const EditBusinessCategory = (BusinessCategory) => {
  return fetch(serverUrl + `api/BusinessCategory`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(BusinessCategory),
  });
};

export const DeleteBusinessCategory = (id) => {
  return fetch(serverUrl + `api/BusinessCategory/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};
//business

export const GetBusinesses = (offset, limit) => {
  return fetch(serverUrl + `api/Business/admin/${offset}/${limit}`, {
    method: "GET",
    headers: header,
  });
};
export const searchBusinesses = (name, offset, limit) => {
  return fetch(
    serverUrl + `api/Business/admin/${offset}/${limit}?name=${name}`,
    {
      method: "GET",
      headers: header,
    }
  );
};

export const GetBusiness = (id) => {
  return fetch(serverUrl + `api/Business/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddBusiness = (Business) => {
  return fetch(serverUrl + `api/Business`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(Business),
  });
};

export const EditBusiness = (Business) => {
  return fetch(serverUrl + `api/Business/Business`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(Business),
  });
};

export const DeleteBusiness = (id) => {
  return fetch(serverUrl + `api/Business/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

// City

export const GetAllCities = () => {
  return fetch(serverUrl + `api/city`, {
    method: "GET",
    headers: header(),
  });
};

export const GetCities = (offset, limit) => {
  return fetch(serverUrl + `api/city/${offset}/${limit}`, {
    method: "GET",
    headers: header,
  });
};

export const GetCity = (id) => {
  return fetch(serverUrl + `api/city/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddCity = (city) => {
  return fetch(serverUrl + `api/city`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(city),
  });
};

export const EditCity = (city) => {
  return fetch(serverUrl + `api/city`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(city),
  });
};

export const DeleteCity = (id) => {
  return fetch(serverUrl + `api/city/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};
//festival_product

export const AddFestivalProduct = (festival) => {
  return fetch(serverUrl + `api/Festival_Product`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(festival),
  });
};

// Festival

export const DeleteFestival = (id) => {
  return fetch(serverUrl + `api/festival/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};
export const GetAllFestivals = (offset, limit) => {
  return fetch(serverUrl + `api/Festival/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetFestivals = (offset, limit) => {
  return fetch(serverUrl + `api/festival/${offset}/${limit}/complet`, {
    method: "GET",
    headers: header(),
  });
};

export const GetFestival = (id) => {
  return fetch(serverUrl + `api/Festival/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddFestival = (festival) => {
  return fetch(serverUrl + `api/festival`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(festival),
  });
};

export const EditFestival = (festival) => {
  return fetch(serverUrl + `api/festival`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(festival),
  });
};

// Machine

export const MachineComplimentrayFilter = (plate, tell) => {
  return fetch(
    serverUrl +
      `api/MachineComplimentray/GetAllByFilter?plate=${plate}&tell=${tell}`,
    {
      method: "GET",
      headers: header(),
    }
  );
};
export const GetMachines = (offset, limit) => {
  return fetch(serverUrl + `api/machine/${offset}/${limit}/complet`, {
    method: "GET",
    headers: header(),
  });
};

export const DeleteMachine = (id) => {
  return fetch(serverUrl + `api/machine/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

export const GetMachine = (id) => {
  return fetch(serverUrl + `api/machine/${id}/complet`, {
    method: "GET",
    headers: header(),
  });
};

export const SendReminderSMS = (type, dayCount) => {
  return fetch(serverUrl + `api/Machine/SendRememmberSMS/${type}/${dayCount}`, {
    method: "GET",
    headers: header(),
  });
};

// UserType

export const GetAllUserTypes = () => {
  return fetch(serverUrl + `api/userType`, {
    method: "GET",
    headers: header(),
  });
};

//Ads

export const AdsconfirmGet = (id) => {
  return fetch(serverUrl + `api/Ads/SetConfirm/${id}`, {
    method: "PUT",
    headers: header(),
    // body: JSON.stringify(data),
  });
};
export const GetAds = (offset, limit) => {
  return fetch(serverUrl + `api/Ads/admin/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetAdsById = (id) => {
  return fetch(serverUrl + `api/Ads/{id}/${id}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddAds = (Ads) => {
  return fetch(serverUrl + `api/Ads`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(Ads),
  });
};

export const EditAds = (Ads) => {
  return fetch(serverUrl + `api/Ads/Ads`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(Ads),
  });
};

export const DeleteAds = (id) => {
  return fetch(serverUrl + `api/Ads/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};
//CategoryAds

export const GetAdsCategories = (offset, limit) => {
  return fetch(serverUrl + `api/CategoryAds/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetAdsCategoryById = (categoryId) => {
  return fetch(serverUrl + `api/CategoryAds/${categoryId}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddAdsCategory = (category) => {
  return fetch(serverUrl + `api/CategoryAds`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(category),
  });
};

export const EditAdsCategory = (category) => {
  return fetch(serverUrl + `api/CategoryAds`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(category),
  });
};

export const DeleteAdsCategory = (categoryId) => {
  return fetch(serverUrl + `api/CategoryAds/${categoryId}`, {
    method: "DELETE",
    headers: header(),
  });
};

// Category

export const GetAllategories = () => {
  return fetch(serverUrl + `api/goodsType`, {
    method: "GET",
    headers: header(),
  });
};
export const GetCategories = (offset, limit) => {
  return fetch(serverUrl + `api/goodsType/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};
export const GetFilterAds = (offset, limit, provinceId, cityId, categoryId) => {
  if (provinceId.length > 0 || cityId.length > 0 || categoryId.length > 0) {
    let questionMarkOrAnd = "?";
    let url = serverUrl;
    url = url + "api/Ads/GetAllByFilterAdmin/" + offset + "/" + limit;
    if (provinceId.length > 0) {
      url = url + questionMarkOrAnd + "provinceId=" + provinceId;
      questionMarkOrAnd = "&";
    }
    if (cityId.length > 0) {
      url = url + questionMarkOrAnd + "cityId=" + cityId;
      questionMarkOrAnd = "&";
    }
    if (categoryId.length > 0) {
      url = url + questionMarkOrAnd + "categoryId=" + categoryId;
    }
    return fetch(
      url,

      {
        method: "POST",
        headers: header(),
      }
    );
  }
};
export const GetFilterAdssimple = (offset, limit) => {
  return fetch(serverUrl + `api/Ads/admin/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetCategory = (categoryId) => {
  return fetch(serverUrl + `api/goodsType/${categoryId}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddCategory = (category) => {
  return fetch(serverUrl + `api/goodsType`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(category),
  });
};

export const EditCategory = (category) => {
  return fetch(serverUrl + `api/goodsType`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(category),
  });
};

export const DeleteCategory = (categoryId) => {
  return fetch(serverUrl + `api/goodsType/${categoryId}`, {
    method: "DELETE",
    headers: header(),
  });
};

// Suggestion

export const GetSuggestions = (offset, limit) => {
  return fetch(serverUrl + `api/feadback/${offset}/${limit}/complet`, {
    method: "GET",
    headers: header(),
  });
};

export const GetSuggestion = (suggestionId) => {
  return fetch(serverUrl + `api/feadback/${suggestionId}`, {
    method: "GET",
    headers: header(),
  });
};

export const DeleteSuggestion = (suggestionId) => {
  return fetch(serverUrl + `api/feadback/${suggestionId}`, {
    method: "DELETE",
    headers: header(),
  });
};

// Complimentary

export const GetComplimentaries = (productId) => {
  return fetch(serverUrl + `api/Complimentary/byProduct/${productId}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetComplimentary = (complimentaryId) => {
  return fetch(serverUrl + `api/Complimentary/ById/${complimentaryId}`, {
    method: "GET",
    headers: header(),
  });
};

export const AddComplimentary = (complimentary) => {
  return fetch(serverUrl + `api/Complimentary`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(complimentary),
  });
};

export const EditComplimentary = (complimentaryId, complimentary) => {
  return fetch(serverUrl + `api/Complimentary/${complimentaryId}`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(complimentary),
  });
};

export const DeleteComplimentary = (complimentaryId) => {
  return fetch(serverUrl + `api/Complimentary/${complimentaryId}`, {
    method: "DELETE",
    headers: header(),
  });
};

// File

export const UploadProductPic = (productId, file, type) => {
  var formData = new FormData();
  formData.append("file", file);

  formData.append("UploadDirectory", `\\images\\goods\\${productId}`);
  formData.append("type", type);
  // formData.append("type", "goods");

  return fetch(serverUrl + `api/image/Upload`, {
    method: "POST",
    headers: {
      apiKey: localStorage.getItem("apiKey"),
    },
    body: formData,
  });
};

// export const UploadProductPic = (file) => {
//   var formData = new FormData();
//   formData.append("file", file);
//   formData.append("UploadDirectory", `images\\goods\\`);

//   return fetch(serverUrl + `api/file/upload`, {
//     method: "POST",
//     headers: {
//       apiKey: localStorage.getItem("apiKey"),
//     },
//     body: formData,
//   });
// };

export const UploadSliderPic = (file) => {
  var formData = new FormData();
  formData.append("file", file, file.name);
  formData.append("UploadDirectory", `img\\slider`);

  return fetch(serverUrl + `api/file/upload`, {
    method: "POST",
    headers: {
      apiKey: localStorage.getItem("apiKey"),
    },
    body: formData,
  });
};

// Purchase

export const GetPurchases = (page, count) => {
  return fetch(serverUrl + `api/Order/${page}/${count}/Complet`, {
    method: "GET",
    headers: header(),
  });
};

export const GetPurchasesForAdmin = (offset, limit) => {
  return fetch(serverUrl + `api/purchase/forAdmin/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetPurchasesForAccountant = (offset, limit) => {
  return fetch(serverUrl + `api/purchase/forAccountant/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetPurchasesByVisitor = (
  fromDate,
  toDate,
  visitorId,
  offset,
  limit
) => {
  return fetch(
    serverUrl + `api/purchase/byVisitor/${visitorId}/${offset}/${limit}`,
    {
      method: "POST",
      headers: header(),
      body: JSON.stringify({ fromDate: fromDate, toDate: toDate }),
    }
  );
};

export const GetPurchasesByCustomer = (
  fromDate,
  toDate,
  customerId,
  offset,
  limit
) => {
  return fetch(
    serverUrl + `api/purchase/byCustomer/${customerId}/${offset}/${limit}`,
    {
      method: "POST",
      headers: header(),
      body: JSON.stringify({ fromDate: fromDate, toDate: toDate }),
    }
  );
};

export const GetPurchasesByDateRange = (fromDate, toDate, offset, limit) => {
  return fetch(serverUrl + `api/purchase/dateRange/${offset}/${limit}`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify({ fromDate: fromDate, toDate: toDate }),
  });
};

export const GetPurchase = (purchaseId) => {
  return fetch(serverUrl + `api/purchase/byId/${purchaseId}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetCompletedPurchases = (offset, limit) => {
  return fetch(serverUrl + `api/Purchase/completed/${offset}/${limit}`, {
    method: "GET",
    headers: header(),
  });
};

export const SetPurchaseToDone = (purchaseId) => {
  return fetch(serverUrl + `api/purchase/done/${purchaseId}`, {
    method: "POST",
    headers: header(),
  });
};

export const SetPurchaseAdminAccept = (purchaseId, state) => {
  return fetch(serverUrl + `api/purchase/adminAccept/${purchaseId}`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify({ state }),
  });
};

export const SetPurchaseAccountantAccept = (purchaseId, state) => {
  return fetch(serverUrl + `api/purchase/accountantAccept/${purchaseId}`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify({ state }),
  });
};

export const SetPurchaseVisitorPaid = (purchaseId) => {
  return fetch(serverUrl + `api/purchase/visitorPaid/${purchaseId}`, {
    method: "POST",
    headers: header(),
  });
};

export const EditPurchase = (purchaseId, purchase) => {
  return fetch(serverUrl + `api/purchase/${purchaseId}`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(purchase),
  });
};

export const DeletePurchase = (purchaseId) => {
  return fetch(serverUrl + `api/purchase/${purchaseId}`, {
    method: "DELETE",
    headers: header(),
  });
};
export const DeleteFestivalProduct = (id) => {
  return fetch(serverUrl + `api/Festival_Product/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

// DataStore

export const GetDataStores = () => {
  return fetch(serverUrl + `api/datastore/0/20`, {
    method: "GET",
    headers: header(),
  });
};

export const UpdateDataStore = (datastore) => {
  return fetch(serverUrl + `api/datastore`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(datastore),
  });
};

// ---------------------Upload image-----------------------------

export const Upload = (file, type) => {
  var formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);

  return fetch(serverUrl + `api/image/upload`, {
    method: "POST",
    headers: {
      token: localStorage.getItem("apiKey"),
    },
    body: formData,
  });
};

// CityBrand

export const GetCityBrandsByCityId = (cityId) => {
  return fetch(serverUrl + `api/CityBrand/admin/${cityId}`, {
    method: "GET",
    headers: header(),
  });
};

export const GetCityBrandsByid = (cityId) => {
  return fetch(serverUrl + `api/CityBrand/${cityId}`, {
    method: "GET",
    headers: header(),
  });
};
export const AddCityBrands = (cityBrands) => {
  return fetch(serverUrl + `api/cityBrand`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(cityBrands),
  });
};

export const DeleteCityBrand = (id) => {
  return fetch(serverUrl + `api/CityBrand/${id}`, {
    method: "DELETE",
    headers: header(),
  });
};

export const DeleteCityBrandGroup = (purchase) => {
  return fetch(serverUrl + `api/CityBrand/DeleteCityBrandGroup`, {
    method: "POST",
    headers: header(),
    body: JSON.stringify(purchase),
  });
};


export const EditCityBrands = (purchase) => {
  return fetch(serverUrl + `api/CityBrand`, {
    method: "PUT",
    headers: header(),
    body: JSON.stringify(purchase),
  });
};
